import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-discount-details-bottomsheet',
  templateUrl: './discount-details-bottomsheet.component.html',
  styleUrls: ['./discount-details-bottomsheet.component.scss']
})
export class DiscountDetailsBottomsheetComponent implements OnInit {

  constructor(
    private bottomSheetRef: MatBottomSheetRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data
  ) { }

  ngOnInit(): void {
    console.log(this.data);
  }

}
